/**
 * Treat date: return date depending on language and specified format
 * @param {string} date
 * @param {string} lang
 */
export const getStringDate = (date = false, lang = 'eng') => {
  date = date ? new Date(date) : new Date()
  let treatedDate = ''
  switch (lang) {
    case 'eng':
      treatedDate = `${date.getFullYear()}-${getMonth(date.getMonth())}-${getDay(date.getDate())}`
      break
    case 'fr':
      treatedDate = `${getDay(date.getDate())}-${getMonth(date.getMonth())}-${date.getFullYear()}`
      break
    default:
      treatedDate = `${date.getFullYear()}-${getMonth(date.getMonth())}-${getDay(date.getDate())}`
      break
  }
  return treatedDate
}

const getMonth = month => {
  if (month < 10) {
    return `0${month - 1}`
  } else {
    return month - 1
  }
}

const getDay = day => {
  if (day < 10) {
    return `0${day}`
  } else {
    return day
  }
}
